import React from 'react'
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ListEmployeeApi } from "../../../../services/Api";
import { genericGet, genericPost } from "../../../../services/Api";
import { EbmsLoading, log } from "../../../../services/Utils";
 


import { SUCCESS_RESULT,ENDPOINTS } from "../../../../Constants";
import { FaTimes, FaEdit, FaFileExport, FaUser, FaPlusCircle, FaTimesCircle, FaSave, FaAd, FaHistory, FaCalendar, FaCalendarAlt } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
 
const CreateMonthlyBudgetAllocations = (props) => {
  const { _staff_id,_month,_year } = (props.location && props.location.state) || {};

  const toggle = () => setshowModal(!showModal);
  const [isLoading, setIsLoading] = useState(false);
 
  
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
const [showModal, setshowModal] = useState(false)
 const [selected_staff, setselected_staff] = useState(null)
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [project_codes, setproject_codes] = useState([])
  const [selected_project, setselected_project] = useState(null)
  const [selected_line, setselected_line] = useState(null)
const [contracted_salary, setcontracted_salary] = useState(0)
const [amount, setamount] = useState(0)
const [percentage, setpercentage] = useState(0)
const [form_data, setForm_data] = useState({})
const [previous_allocs, setprevious_allocs] = useState([])
const [yearly_allocations, setYearly_allocations] = useState([])

const [lines, setlines] = useState([])
const [year, setyear] = useState(null)
const [month, setmonth] = useState(null)
  useEffect(() => {

    


if(_month!=null){
  
  setmonth(_month);
  setyear(_year);
}
 
   
setTimeout(() => {
  fetch_data();
  loadProjects();
}, 100);
  
    return () => {};
  }, []);
  
  const updateData = e => {
    setForm_data({
        ...form_data,
        [e.target.name]: e.target.value
    })
}

const get_month_name=(month)=>{

 const date = new Date(year, month-1, 1);   
 const month_name = date.toLocaleString('default', { month: 'long' });
 return month_name;
}

const removeLine=(budget_line)=>{
  let _lines=lines;
  _lines=_lines.filter(function( obj ) {
    return obj.budget_line !== budget_line;
})
  setlines([]);
  setlines(_lines);

}

const get_total_percentage=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.percentage);
  })
  return total;

}
const get_total_amount=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.amount);
  })
  return total;

}
const add_budget=(e)=>{
  e.preventDefault();
 
  
  // validations
 

let line_exist=lines.filter(function( obj ) {
  return obj.budget_name == form_data?.budget_name;
});

if(line_exist?.length  > 0 ){
  cogoToast.error("Budget line already added  " , {
    hideAfter: 5,
});
  return;
}
if(!form_data?.amount>0){
  cogoToast.error("Amount should be greater than Zero. " , {
    hideAfter: 5,
});
return;
}

if(Number(get_total_percentage())+Number(form_data?.percentage) > 100){
  cogoToast.error("Percentage could not Exceed 100%  " , {
    hideAfter: 5,
});
return;
}




// END OF VALIDATIONS
let _lines=lines;

  setlines([]);
  _lines.push(form_data);
  setTimeout(() => {
 
    setlines(_lines);
    document.getElementById("form").reset();
    setForm_data(null)
  }, 100);
 
 

}

const  delete_allocation=(id)=>{
  setIsLoading(true);
  alert(id)
  genericPost(ENDPOINTS.DELETE_MONTHLY_ALLOCATION, {
    "monthly_allocation_id": id
   })
    .then((res) => {
      console.log(res)
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          cogoToast.success("Allocation Deleted Successfully", {});
          get_previous_allocations(selected_staff?.id);
          
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}
const saveBudgetAllocation=()=>{
  if(Number(get_total_percentage()) != 100){
    cogoToast.error("Total Percentage should be 100%  " , {
      hideAfter: 5,
  });
  return;
  }
let data={
  staff_id:selected_staff?.id,
  allocations:lines
  ,
  month:month,
  year:year

}
console.clear();
console.log("DataToSend",data)
setIsLoading(true);
 
genericPost(ENDPOINTS.CREATE_MONTHLY_ALLOCATIONS, data)
  .then((res) => {

    setIsLoading(false);
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        let data = res.data.data;
        // clean-up
        setlines([])
        get_previous_allocations(selected_staff?.id);
        console.log("Create-allocation Result",data)
        cogoToast.success(res.data.message, {});


   
      } else {
        cogoToast.error(res.data.message, {});
      }

    }

  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });


}
const get_previous_allocations=(id)=>{
  
  setIsLoading(true);
  genericPost(ENDPOINTS.LIST_MONTHLY_ALLOCATIONS_PER_STAFF, {
    "staff_id": id,
    "month":month??_month,
    "year":year??_year
   })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
          setprevious_allocs(responseData)
        } else {
          cogoToast.error(res.data.message, {});
          console.clear();
          console.log("payload",{
            "staff_id": id,
            "month":month,
            "year":year
           })
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}
const get_yearly_allocations=(id)=>{
  setIsLoading(true);
  genericPost(ENDPOINTS.STAFF_ALLOCATIONS, {
    "staff_id": id
   })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
          setYearly_allocations(responseData)
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}


  const loadProjects = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.GET_PROJECT_CODES, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            log("setproject_codes",responseData);
            // log("RIGHTS: ", responseData);
            setproject_codes(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const fetch_data = () => {
    setProcessing(true);

    ListEmployeeApi()
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
            

            if( _staff_id!=null){
              let rc= 
              response.data.filter(function( obj ) {
                return obj.id === _staff_id;
            })[0];
            console.log("_staff_id",_staff_id)

              console.log("rc",rc)
              console.log("respc",response.data)
     setselected_staff(rc);
  
     setcontracted_salary(rc.contracted_salary);
     get_yearly_allocations(rc?.id);
     get_previous_allocations(rc?.id);
            }



          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);


  return (
 
        <div className="card" style={{ width: "95%", margin: "auto",padding:"50px",paddingTop:"5px" }}>


    
    <div class="card-body">

    <div className="row">
  <div className='col-md-10'>
  <h1>Monthly Budget Allocations  {selected_staff!=null && <> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <FaCalendarAlt></FaCalendarAlt>   {get_month_name(month)} , {year} </>}  </h1>

  </div>
  <div className='col-md-2'>
   {selected_staff==null? <></> : <button className='btn btn-danger'  onClick={(e)=>{setselected_staff(null); setmonth(null); setyear(null)}}><FaTimes></FaTimes> &nbsp;Close </button>}
    
    </div>
</div>

 

    </div>
    
{selected_staff==null?
<center>
  <hr/>
  <div className="row">
  <div className="col-md-3"></div>
 <div className="col-md-3">
    Month  
    <select name="month"
            className="form-control"
            onChange={(e) => {setmonth(e.target.value)}
               
             
            }
            required={true}
          >
            <option value=''>Select Month </option>
            <option value={1}>January </option>
            <option value={2}>February </option>
            <option value={3}>March </option>
            <option value={4}>April </option>
            <option value={5}>May </option>
            <option value={6}>Jun </option>
            <option value={7}>July </option>

            <option value={8}>August </option>
            <option value={9}>September </option>
            <option value={10}>October </option>
            <option value={11}>November </option>
            <option value={12}>December </option>

          


            
          </select>

</div>
 
<div className="col-md-2">  Year
<input className="form-control" name="year"   value={year} onChange={(e)=>setyear(e.target.value)} required={true}></input>
 
  </div>
  <div className="col-md-2"> <br/>
<button className='btn btn-primary'  disabled={year==null || month==null} onClick={(e)=>{setshowModal(true);}}><FaUser></FaUser> &nbsp;SELECT STAFF </button>

</div>
</div>

</center>
:
    <>

     
     
     <table className='info_table'> 
<thead>


<th>STAFF ID</th>
<th>STAFF NAME</th>
<th>ROLE </th>
<th>EMAIL </th>

<th>OFFICE  </th>
<th>SALARY  </th>
<th>CONTRACT END DATE  </th>




</thead>

<tr>
  <td>
    {selected_staff?.staff_id}
  </td>
  <td>
   <b> {selected_staff?.staff_name} </b>
  </td>

  <td>
    {selected_staff?.role_name}
  </td>
  <td>
    {selected_staff?.email}
  </td>
  <td>
    {selected_staff?.office_name}
  </td>


  <td>
    {selected_staff?.contracted_salary}
  </td>
  <td>
    {selected_staff?.contract_end_date}
  </td>
  
</tr>

     </table>

<div>
  <br/>
  <h1><FaHistory></FaHistory>  Allocated Budgets for  {get_month_name(month)} , {year}</h1>
</div>
 
 
<table className='info_table'>

<thead>
  <th>Project Name</th>
  <th>Budget Code</th>

  <th>Budget Name</th>
  

  <th>Created By  </th>
 
  <th>Percentage</th>
  <th>Amount</th>
 
  <th>..</th>


</thead>

{previous_allocs?.map((p)=>{
  return <tr>
      <td>{p.project_name}</td>
      <td>{p.budget_code}</td>
      <td>{p.budget_name}</td>
    
     
      <td>{p.created_by}</td>
    <td>{p.percentage}</td>
    <td>{p.amount}</td>
   
    <td> <FaTimesCircle style={{color:"red"}} onClick={()=>{
      if(window.confirm("Are you sure to delete this allocation?")){
delete_allocation(p.id);
      }
    }}></FaTimesCircle> </td>

  

  </tr>
})}
</table>
<hr/>
<h1><FaPlusCircle></FaPlusCircle> &nbsp;Add New Allocations</h1>
<div className='row'>
<div className='col-md-4 p-10'>
  
 <form onSubmit={add_budget}  id="form"  >
  Budget
<select  className='form-control select2' data-control="select2" name="project_id" id="project_id" onSelect={(e)=>{
  alert(3334)
}} onChange= {()=>{
  var e = document.getElementById("project_id");
  var name = e.options[e.selectedIndex].text;
  var value = e.options[e.selectedIndex].value;
  setForm_data({
    ...form_data,
    ["allocation_id"]: value,
    ["budget_name"]: name

})
 console.clear();
 

}}> 
<option value="">.. Select Budget ..</option>
{yearly_allocations?.map((p)=>{
  return <option value={p.id}>{p.budget_code} - {p.budget_name} ({p.percentage}%) </option>
})}


</select>

 
PERCENTAGE (%)
<input className='form-control' name="percentage"     onChange={(e)=>{
  try{
 
    let amt=(Number(e.target.value)/100)*contracted_salary;

    setForm_data({
      ...form_data,
      ["amount"]: amt,
      ["percentage"]: e.target.value
  })

  }catch(e){ 
  }
}}/> 

AMOUNT ($) 
<input className='form-control' name="amount"  disabled={true} value={form_data?.amount}/>  

<button type='submit' className='btn btn-primary'  ><FaPlusCircle></FaPlusCircle> &nbsp;  Add</button> 
</form>
 
</div>


<div className='col-md-8'>
  Selected Allocations
 
 

<table className='info_table'>
    <thead>
 
<th>Budget Line</th>
<th>Percentage</th>
<th>Amount</th>
<th>...</th>




    </thead>
  {lines?.map((l)=>{
 
    return <tr>
      
      <td>{l.budget_name}</td>      
      <td>{l.percentage}%</td>
      <td>${l.amount}</td>
      <td><FaTimesCircle style={{color:"red"}} onClick={(e)=>removeLine(l.budget_line)}></FaTimesCircle> </td>

    </tr>
  })}
  <tr>
    <td colSpan={1}></td>
    <td> <b> {get_total_percentage()} %</b> </td>

    <td> <b>${get_total_amount()}</b> </td>
    <td></td>

  </tr>
</table>
<br/>
  <button className='btn btn-success' disabled={lines.length==0}  onClick={()=>saveBudgetAllocation()}><FaSave></FaSave> &nbsp; SAVE ALLOCATION </button>
</div>
</div>












</>
}


    <Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             SELECT STAFF        
          </div>
    
         </ModalHeader>
        <ModalBody>
      
 
        <div className="ag-theme-alpine">
      <AgGridReact
        suppressMenuHide={true}
        ref={gridRef}
        

    
        onGridReady={(params) => {
          setGridApi(params.api);
         
        }}
        rowData={rowData}
        domLayout={"autoHeight"}
        animateRows={true}
        onRowClicked={(e) => {
          setshowModal(false);
          setselected_staff(e.data);
          console.log(e.data)
          setcontracted_salary(e.data.contracted_salary);
          get_yearly_allocations(e.data?.id);
          get_previous_allocations(e.data?.id);

          

        
        }}
        pagination={true}
        paginationPageSize={5}
        defaultColDef={defaultColDef}
        resizable={true}
        enableCellTextSelection={true}
        suppressCellSelection={true}
        columnDefs={[
          {
            headerName: "Staff ID",
            field: "staff_id",
            sortable: true,
            filter: true,
            maxWidth: 150,
          },
          {
            headerName: "Staff Name",
            field: "staff_name",
            sortable: true,
            filter: true,
          },
          {
            headerName: "Salary",
            field: "contracted_salary",
            sortable: true,
            filter: true,
          },
        ]}
      ></AgGridReact>
    </div> 
     
     
        </ModalBody>
      
      </Modal>
     
  </div>
  )
}

export default CreateMonthlyBudgetAllocations

